<template>
  <div class="separation-anxiety-do-it-yourself-card">
    <va-card title="Do-It-Yourself Separation Anxiety Program">
      <div class="do-it-yourself">
        <div class="image-container">
          <img src="../../assets/dog-couch-camera.jpg" alt="Camera looking at dog on couch" />
        </div>
        <div class="content-container">
          <p>This self-paced behavior modification course
            is specifically designed so both dog pros and
            dog companions can learn step by step what
            is separation anxiety, how to find out if their
            dog suffers from it, and how to set up an
            effective daily training plan to help him/her
            overcome it.
          </p>
          <p>
            This program created by Separation Anxiety
            Dog includes 20 dynamic, and easy to follow
            video modules that will guide you through
            each stage of your separation anxiety
            journey, so you can move forward knowing
            when and what to do next.
          </p>
          <a href="https://separationanxietydog.thinkific.com/courses/do-it-yourself-separation-anxiety-program?ref=c0c8d0"
            alt="Separation Anxiety Do it Yourself Program"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            :style="{color: this.$themes.primary}" >
            <va-button>Learn More</va-button>
          </a>
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>

export default {
  name: 'separation-anxiety-do-it-yourself-card',
}
</script>

<style scoped lang="scss">
.separation-anxiety-do-it-yourself-card {
  .do-it-yourself {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include media-breakpoint-up(lg) {
      display: flex;
      flex-direction: row;
    }

    .image-container {
      width: 90%;
      overflow: hidden;

      @include media-breakpoint-up(lg) {
        height: 120%;
        width: auto;
        margin-top: 2rem;
      }

      img {
        width: 100%;
        height: auto;
        border-radius: 0.375rem;
      }
    }

    p {
      margin-top: 1rem;
    }

    .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 1rem;
    }

    .content-container {
      @include media-breakpoint-up(lg) {
        margin-left: 2rem;
      }
    }
  }
}
</style>
